import React, { useState, useEffect } from 'react';
import '.././styles/trivia.css';
import TriviaGame from './Trivia';
import GameNav from '../GameNav';


const TRiviaHome = () => {
    return (
        <div className='trivia-main'>
            <GameNav />
            <TriviaGame />
        </div>
    )
};
export default TRiviaHome;